<template>
<div>
	
	<button @click="dd">
hola
	</button>
<InventarioBowtie
          :editRisk="true"
          :saveChange="saveChange"
          :action="action"
          :onAcept="addCustomRisk"
          :onClose="handleClose"
          :visibleSync="true"
          :editable="true"
          :risk="newCustomRisk"
          :allStandardRisks="risks"
          :riskItem="riskItem"
          :closeDialogCustomRisk="closeDialogCustomRisk"/>
</div>
    
</template>

<script>
import InventarioBowtie from '@/components/DialogInventarioBowtie.vue';
import { mapGetters } from 'vuex';
import { isRiskReady, iframeMessages } from '@/utils/generalFunctions';

export default {
	data() {
		return {
      editRisk: false,
      action: 'add',
			openDialogBowtie: false,
      newCustomRisk: {
        _id: "",
        nombre: "",
        tipo: "seguridad",
        evento_no_deseado: "",
        control_adicional: "",
        energia: "",
        calculo_mfl: "",
        peligro: "",
        standardRisk: false,
        material: false,
        causas: [],
        custom: true,
        impactos: [],
        escenario: "",
        justificacion_evaluacion: "",
        kri: [],
        escenario_residual: "",
        escenario_mfl: "",
        faena_id: "",
        medioambiental: false,
        medioambiente: {},
        evaluadores: [],
        sin_controles: {
          severidad: 0,
          probabilidad: 0
        },
        con_controles: {
          severidad: 0,
          probabilidad: 0
        },
        responsable: "",
        fecha: ""
      }
		}
	},
	created(){

function displayMessage (evt) {
	console.log("I got  from " ,evt.data);
}
iframeMessages(displayMessage)

	}, // created
  components: {
    InventarioBowtie,
	},
	methods:{

    ...mapGetters({
      risks: 'allRisks',
		}),
		isRiskReady,
		dd(){
			window.name = {'no':'si'}
			window.parent.postMessage({hola:'aaaa'}, "http://localhost:8081");
			/* console.log(window.parent)
	window.parent.saludar('hola desde inv') */
		},
    closeDialogCustomRisk() {
      this.formCustomRisk.nombre = '';
      this.formCustomRisk.tipo = null;
      this.dialogNewCustomRisk = false;
      this.standard_risks = [];
      this.standard_risks_original = [];
      this.standard_risk_found = false;
      this.standard_risk_message = '';
      this.noStandardRiskLeft = false;
      this.srrLoading = false;
      this.formCustomRisk.standardRisk = null;
      this.standardRiskButtonEnabled = false;
    },
    riskItem() {

    },
		saveChange(risk) {
      if (this.isRiskReady(risk).status === true) {
				//this.$store.dispatch('editCustomRisk', risk);
				window.parent.postMessage({risk}, "http://localhost:8081");
        this.$notify.info({
          duration: 3000,
          title: 'Atención',
          message: `Riesgo ${risk.nombre} modificado exitosamente`,
        });
        // this.resetStatusRisk();
        // this.forceRerender();
        this.handleClose();
        //this.saveInventory();
      } else {
        let textError = '';
        for (
          let index = 0;
          index < this.isRiskReady(this.newCustomRisk).errors.length;
          index++
        ) {
          textError = `${textError}<li class="listaError">${
            this.isRiskReady(this.newCustomRisk).errors[index]
          }</li>`;
        }
        this.$alert(`<ol class="listaError">${textError}</ol>`, 'Atención', {
          type: 'error',
          dangerouslyUseHTMLString: true,
        });
      }
		},

    addCustomRisk() {

   		window.parent.postMessage({risk: this.newCustomRisk}, "http://localhost:8081");
        if (this.isRiskReady(this.newCustomRisk).status === true) {
          // this.$store.dispatch('addRisk', this.newCustomRisk);
          this.$notify.info({
            duration: 3000,
            title: 'Atención',
            message: `Riesgo ${
              this.newCustomRisk.nombre
            } fue agregado exitosamente`,
          });
          // this.saveInventory();
          this.handleClose();
        } else {
          this.errores = [];
          for (
            let index = 0;
            index < this.isRiskReady(this.newCustomRisk).errors.length;
            index++
          ) {
            this.errores.push(this.isRiskReady(this.newCustomRisk).errors[index]);
          }
          this.dialogError = true;
        }
      
		},
    handleClose() {
     /*  this.dialogError = false;
      this.openDialogBowtie = false;
      this.dialogNewCustomRisk = false;
      this.dialogEditCustomRisk = false;
      this.dialogAddSecurityRisk = false;
      this.risksSelected = [];
      this.dialogAddHealthRisks = false;
      this.dialogAddMedioambienteRisks = false; */
      this.newCustomRisk = {
        _id: '',
        nombre: '',
        tipo: null,
        standardRisk: false,
        material: false,
        causas: [],
        custom: true,
        impactos: [],
        escenario: '',
        faena_id: '',
        medioambiental: false,
        medioambiente: {},
        evaluadores: [],
        causas: [],
        status: 0,
        status_step: 0,
        status_by: null,
        status_position: null,
        status_message: null,
      };
      this.editRisk = false;
    },
	} // methods
}
</script>
